import React from 'react';
import { motion } from 'framer-motion';

const HomepageSections = ({ sections }) => {
  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <>
      {sections.map(({ Component, key, props }) => (
        <motion.div key={key} variants={itemVariants}>
           <Component {...props} />
        </motion.div>
      ))}
    </>
  );
};

export default HomepageSections;